import React from "react";

export const BarFullSVG: React.FC = () => (
  <div
    style={{
      position: "relative",
      display: "flex",
      maxWidth: "",
      width: "100%",
    }}
  >
    <svg
      viewBox="0 0 600 136"
      width="100%"
      height="auto"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMid meet"
    >
      {/* Gradient Bars */}
      <path
        d="M0 62.5C0 60.2909 1.79086 58.5 4 58.5H150V90.5H4C1.79086 90.5 0 88.7091 0 86.5V62.5Z"
        fill="url(#paint0_linear_424_54236)"
        fillOpacity="0.8"
      />
      <path
        d="M150 58.5H596C598.209 58.5 600 60.2909 600 62.5V86.5C600 88.7091 598.209 90.5 596 90.5H150V58.5Z"
        fill="url(#paint1_linear_424_54236)"
        fillOpacity="0.8"
      />
      {/* Green and Red Markers */}
      <rect x="148.5" y="58.5" width="3" height="32" fill="#009244" />
      <rect x="234.835" y="58.5" width="3" height="32" fill="#B70100" />
      <rect x="148.168" y="58.5" width="3" height="44" fill="#009244" />
      <rect x="235.168" y="58.5" width="3" height="44" fill="#B70100" />
      {/* White Bar and Quartiles */}
      <rect x="70" y="73.5" width="390" height="2" fill="white" />
      <rect x="179" y="71.5" width="112" height="6" fill="white" />
      {/* Marker Dot */}
      <circle
        cx="203"
        cy="74.5"
        r="7"
        fill="#06AFFF"
        stroke="white"
        strokeWidth={2}
      />
      {/* Gradients */}
      <defs>
        <linearGradient
          id="paint0_linear_424_54236"
          x1="0"
          y1="74.5"
          x2="150"
          y2="74.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00682F" />
          <stop offset="1" stopColor="#75CB1E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_424_54236"
          x1="150"
          y1="74.5"
          x2="600"
          y2="74.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFD92" />
          <stop offset="0.0384615" stopColor="#FCCE17" />
          <stop offset="0.516643" stopColor="#D90C20" />
          <stop offset="1" stopColor="#42105F" />
        </linearGradient>
      </defs>
    </svg>
  </div>
);
